import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
// import Button from "../../../components/Button";
// import classes from "../report.module.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { TableSearch } from "../../../components/Table/TableActions";
import Table from "../../../components/Table/Table";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../components/PageLoader";
import nosearch from "../../../assets/images/no-search.svg";
import NotFounditem from "../../error/NotFound";
import { useUserState } from "../../../context/UserContext";
import useStyles from "../styles";
// import useWindowSize from "../../../hooks/useWindow";

const CLASSES_ENDPOINT = "/api/v1/class";
const TEACHERS_CLASS_ENDPOINT = "/api/v1/teacher/classes";

const SessionBroadsheet = () => {
  const classes = useStyles();
  const [classesData, setClassData] = useState([]);
  const { userRole } = useUserState();
  const [isPageFetching, setIsPageFetching] = useState(false);
  const isTeacher = userRole?.role_type === "employee";
  const [teacherClassData, setTeacherClassData] = useState([]);
  const [searchResult, setSearchResult] = useState([]);

  // const width = useWindowSize();
  // const mobile = width < 600;

  const navigate = useNavigate();

  /**
   * Fetches all physical classes from the server and updates the state.
   * @function
   * @returns {void}
   * @description This function makes an HTTP GET request to the CLASSES_ENDPOINT,
   * filters the response to only include physical classes, and updates the classData state.
   * It also manages the loading state with setIsPageFetching.
   */
  const getAllClasses = () => {
    setIsPageFetching(true);
    httprequest
      .get(isTeacher ? TEACHERS_CLASS_ENDPOINT : CLASSES_ENDPOINT)
      .then((res) => {
        const teacherClass = res?.data?.data?.map(item => item.class) || [];
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setIsPageFetching(false);
        setClassData(physicalClasses);
        setTeacherClassData(teacherClass);
        setSearchResult(isTeacher ? teacherClass : physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  // Define the columns for the notice table
  const columns = [
    {
      name: "Class",
      selector: (row) => (
        <>
          {/* {mobile && <p className="mobile-styling">Student</p>} */}
          {row?.class_name || row?.name || "--/--"}
        </>
      )
    },
    {
      name: "No of Student",
      selector: (row) => (
        <>
          {/* {mobile && <p className="mobile-styling">Student</p>} */}
          {row?.no_of_students || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={() => navigate(`/reports/sessionbroadsheet/${row?.id || row?.class_id}`)}>
            <Icon icon="mingcute:right-line" />
          </button>
        </div>
      )
    }
  ];

  // --| Filter Notice table using title, description, priority who can access
  const handleSearchNotice = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = isTeacher ? teacherClassData : classesData?.filter((data) => valArray?.every(
      (word) => data?.class_name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.priority?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    getAllClasses();
  }, []);

  return (
    <div className="page-content no_padding_0">
      <div className="page-content margin-top-16">
        {isPageFetching ? (
          <PageLoader />
        ) : (isTeacher ? teacherClassData.length === 0 : classesData.length === 0) ? (
          <div className={classes.notfound}>
            <NotFounditem
              img={nosearch}
              title="No Exam BroadSheet Found"
              subtitle="No Broadsheet has been added to the list."
            />
          </div>
        ) : (
          <div className={classes.classListView}>
            <div>
              {(isTeacher ? teacherClassData?.length > 0 : classesData?.length > 0) ? (
                <div>
                  <Table
                    data={searchResult}
                    columns={columns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      <TableSearch
                        placeholder="Search by title..."
                        searchTableFunc={handleSearchNotice}
                      />
                    }
                  />
                </div>
                // <div className={classes.classesGrid}>
                //   {(isTeacher ? teacherClassData : classesData)?.map((classItem, index) => (
                //     <Box
                //       key={classItem?.id || classItem?.class_id || index}
                //       className={classes.classBox}
                //       onClick={() => navigate(`/reports/sessionbroadsheet/${classItem?.id || classItem?.class_id}`)}
                //     >
                //       <div className={classes.classBoxContent}>
                //         <span className={classes.className}>
                //           {isTeacher ? classItem?.name : classItem?.class_name}
                //         </span>
                //       </div>
                //     </Box>
                //   ))}
                // </div>
              ) : (
                <div className={classes.noClasses}>
                  <NotFounditem
                    img={nosearch}
                    title="No Classes Found"
                    subtitle="No classes have been assigned to you yet."
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
};

export default SessionBroadsheet;
